import { useUserMeControllerUserMeQuery } from '@shared/services/apiService/apiService';
import { useAppDispatch } from '@shared/store';
import { actions } from '@shared/store/ducks';
import { useEffect } from 'react';
import { AnimatedOutlet } from '@shared/components/AnimatedOutlet';
import { InitialPageLoader } from '@shared/components/InitialPageLoader';
import { useAuthenticatedUserCompanySync } from '@shared/hooks/useAuthenticatedUserCompanySync';

export const UserLoader: React.FC = () => {
  const dispatch = useAppDispatch();
  const {
    data: userData,
    isLoading: isUserLoading,
    error,
    refetch,
  } = useUserMeControllerUserMeQuery();
  const { isCompanyLoading } = useAuthenticatedUserCompanySync(userData?.companyId);

  useEffect(() => {
    if (userData) {
      dispatch(actions.auth.setAuthenticatedUser(userData));
    }
  }, [userData, dispatch]);

  useEffect(() => {
    const handleRefreshUser = () => {
      if (document.visibilityState === 'visible') {
        refetch();
      }
    };

    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === 'call-agent:user-role-updated-at' || event.key === 'accessToken') {
        refetch();
      }
    };

    window.addEventListener('focus', handleRefreshUser);
    document.addEventListener('visibilitychange', handleRefreshUser);
    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('focus', handleRefreshUser);
      document.removeEventListener('visibilitychange', handleRefreshUser);
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [refetch]);

  if (isUserLoading || isCompanyLoading) return <InitialPageLoader />;
  if (error) return <div>Error during loading user data.</div>;

  return <AnimatedOutlet />;
};
